import React, { Suspense } from 'react';
import './App.scss';
import { routePath } from './common/routes';
import { Route, Routes } from 'react-router-dom';
import { WebContextProvider } from './contextProvider/webContextProvider';
import PageLoader from './components/PageLoader';
import GoogleTagManager from './helper/GoogleTagManager';
import ErrorBoundary from './components/ErrorBoundary';

export const App = () => {
  return (
    <ErrorBoundary level="app">
      <React.Fragment>
        <GoogleTagManager />
        <WebContextProvider>
          <Routes>
            {routePath.map(route => {
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <Suspense fallback={<PageLoader />}>
                      <route.component />
                    </Suspense>
                  }
                />
              );
            })}
          </Routes>
        </WebContextProvider>
      </React.Fragment>
    </ErrorBoundary>
  );
};
